// extracted by mini-css-extract-plugin
export default {"label":"DirectDeposit_label__ji64K","table":"DirectDeposit_table__Od-Yr","buttonContainer":"DirectDeposit_buttonContainer__SDE4L","button":"DirectDeposit_button__sUBM3"};